<template>
  <div class="pickable-buttons">
    <button
      v-for="option in options"
      :key="option[trackOptionsBy]"
      class="pickable-buttons-option"
      :class="{
        'pickable-buttons-option-selected': selectedOption?.[trackOptionsBy] &&selectedOption?.[trackOptionsBy] === option[trackOptionsBy]
      }"
      @click="handleOptionClick(option)"
    >
      <div class="pickable-buttons-option-label">
        {{ option.label }}
      </div>

      <div class="pickable-buttons-option-description">
        {{ option.description }}
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PickableButtons',
  props: {
    value: {
      type: undefined,
      default: undefined
    },
    options: {
      type: Array,
      required: true
    },
    trackOptionsBy: {
      type: [String, Number],
      default: 'label'
    }
  },
  data() {
    return {
      selectedOption: this.value
    }
  },
  methods: {
    handleOptionClick(option) {
      this.selectedOption = option

      this.$emit('input', this.selectedOption)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@/../static/stylesheets/variables" as *;

.pickable-buttons {
  display: flex;
  gap: 1rem;

  &-option {
    display: flex;
    flex-direction: column;
    user-select: none;
    cursor: pointer;
    background-color: transparent;
    margin: 0;
    border: 1px solid #CCCCCC;
    border-radius: 0.25rem;
    padding: 1rem;
    width: 14rem;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    /** @note Necessary rule to reset some unnecessary inherited styles (Due to the usage of style tag without scoped). */
    height: auto;
    font-size: medium;
    font-weight: normal;
    transition: none;
    animation-duration: initial;
    color: initial;

    &-selected {
      border-color: $theme-primary-color;
    }
  }

  &-option-label {
    font-size: 0.75rem;
    font-weight: 500;
    color: $theme-primary-color;
    text-transform: uppercase;
  }

  &-option-description {
    font-size: 0.875rem;
    font-weight: 500;
    color: #999999;
  }
}
</style>
